module.exports = __webpack_public_path__ + "img/h6.da6eaeea.png";